
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.033 2H6.967A4.973 4.973 0 002 6.967v8.066A4.973 4.973 0 006.967 20h8.066A4.973 4.973 0 0020 15.033V6.967A4.973 4.973 0 0015.033 2zm3.37 13.033a3.374 3.374 0 01-3.37 3.37H6.967a3.374 3.374 0 01-3.37-3.37V6.967a3.374 3.374 0 013.37-3.37h8.066a3.374 3.374 0 013.37 3.37v8.066zM11 6.286A4.72 4.72 0 006.286 11 4.72 4.72 0 0011 15.714 4.72 4.72 0 0015.714 11 4.72 4.72 0 0011 6.286zm0 7.805A3.094 3.094 0 017.909 11 3.095 3.095 0 0111 7.909 3.095 3.095 0 0114.091 11 3.094 3.094 0 0111 14.09zm5.143-9.52a1.29 1.29 0 00-1.286 1.286c0 .338.138.67.378.91.238.238.57.376.908.376.339 0 .67-.138.91-.377.239-.24.376-.571.376-.909 0-.339-.137-.67-.377-.91a1.291 1.291 0 00-.91-.376z"}})])
          )
        }
      }
    